import { IShapefileNode } from "models/projects";

import { useStructuredNodeContext } from "components/project/layers/components/layer-managers/project-layer-tree/node-manager/context/StructuredNodeContext";
import {
  acceptNodeChanges,
  cancelNodeChanges
} from "components/project/layers/components/layer-managers/project-layer-tree/node-manager/context/reducer";
import { useProjectDispatch } from "components/project/projects/context";
import { useUpdateProjectShapefileFolderMutation } from "components/project/shapefiles/mutations";

type UseAcceptShapefileFolderChangesParams = {
  node: IShapefileNode;
  projectId: string;
};

type UseAcceptShapefileFolderChangesReturn = {
  isLoading: boolean;
  mutate: (e?: React.SyntheticEvent) => void;
};

export function useAcceptShapefileFolderChanges(
  params: UseAcceptShapefileFolderChangesParams
): UseAcceptShapefileFolderChangesReturn {
  const { node, projectId } = params;
  const [{ editableTitle, originalTitle }, nodeDispatch] = useStructuredNodeContext();
  const projectDispatch = useProjectDispatch();

  const updateProjectShapefileFolder = useUpdateProjectShapefileFolderMutation({
    onSuccess: () => {
      acceptNodeChanges(nodeDispatch, (isDraggable) =>
        projectDispatch({ payload: { isTreeDraggable: isDraggable } })
      );
    }
  });

  const mutate = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (originalTitle === editableTitle) {
      cancelNodeChanges(nodeDispatch, (isDraggable) =>
        projectDispatch({ payload: { isTreeDraggable: isDraggable } })
      );
      return;
    }

    updateProjectShapefileFolder.mutate({
      body: { key: "name", value: editableTitle },
      projectId: projectId,
      shapefileNodeId: node.shapefileNodeId
    });
  };

  return { mutate, isLoading: updateProjectShapefileFolder.isLoading };
}
